import React, { PropsWithChildren } from "react";
import RenderWhen from "../RenderWhen";
import Heading from "./Heading";

interface DynamicAnalysisTitleProps {
  headingLevel: "h1" | "h2" | "h3" | "h4" | "h5";
  icon?: React.ReactElement;
  title: string;
}

const Title: React.FC<PropsWithChildren<DynamicAnalysisTitleProps>> = ({
  headingLevel = "h1",
  icon,
  title,
  children
}) => (
  <div className="dynamic_analysis__title">
    <div className="dynamic_analysis__title-text">
      <RenderWhen condition={Boolean(icon)}>{icon}</RenderWhen>
      <Heading level={headingLevel}>{title}</Heading>
    </div>
    {children}
  </div>
);

export default Title;
